import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import { XhrHttpHandler } from '@aws-sdk/xhr-http-handler';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';
export interface AWSCredentials {
  AccessKeyId: string;
  SecretAccessKey: string;
  UserName: string;
  CreateDate: string;
  Status: string;
}

export const getAwsTemporaryCredentials = async (labId: string) => {
  const res = await apiRequestHandlerPromise({
    url: `createAwsTemporaryCredentials?labId=${labId}`,
    method: 'GET',
  });
  await new Promise((resolve) => setTimeout(resolve, 10000)); // TODO get rid of this;
  return res;
};

export const deleteAwsTemporaryCredentials = async (credentials: Partial<AWSCredentials>) => {
  const { AccessKeyId, UserName } = credentials;

  return apiRequestHandlerPromise({
    url: 'awsTemporaryCredentials',
    method: 'DELETE',
    data: JSON.stringify({
      AccessKeyId,
      UserName,
    }),
  });
};

export const getS3UploadObject = (
  creds: AWSCredentials,
  labId: string,
  studyId: string,
  file: File,
  customerBucketName?: string | null
) => {
  const abortController = new AbortController();
  const requestHandler = new XhrHttpHandler({ requestTimeout: 2000000 });
  const handleRequest = requestHandler.handle.bind(requestHandler);
  requestHandler.handle = (request, options = {}) =>
    handleRequest(request, {
      ...options,
      abortSignal: request.method === 'DELETE' ? options.abortSignal : abortController.signal,
    });
  const s3 = new S3Client({
    region: 'us-east-2',
    credentials: {
      accessKeyId: creds.AccessKeyId,
      secretAccessKey: creds.SecretAccessKey,
    },
    requestHandler,
    requestChecksumCalculation: 'WHEN_REQUIRED',
  });

  const params = {
    Bucket: customerBucketName || `nuc-cst-us-east-2-${labId}`,
    Key: `ATOM/${studyId}/Incoming/${file.name}`,
    Body: file,
  };

  const upload = new Upload({
    client: s3,
    params,
    abortController,
  });

  return upload;
};
